import * as ec from '@attain-apps/fe/web/main/lib/entity-collection'

import type { TypeParams } from '../../types'

import { getActionsConfig } from './actions'
import { Api } from './api'
import * as effects from './effects'
import * as extraReducers from './extra-reducers'
import { Selectors } from './selectors'
import { State } from './state'

/**
 * Manages joint use state as a plugin of the organizations collection.
 */
export class Plugin extends ec.plugins.Plugin<
  TypeParams,
  typeof Plugin.id,
  State,
  Selectors,
  ReturnType<typeof getActionsConfig>
> {
  /** @see {@link ec.plugins.Plugin.Id.Custom} */
  public static id = ec.plugins.Plugin.Id.Custom.create('JointUse')

  /** @see {@link Api} */
  public readonly api: Api = new Api()

  constructor({ collection }: Readonly<Plugin.constructor.Params>) {
    super({
      actions: getActionsConfig(),
      collection,
      id: Plugin.id,
      initialState: State.INITIAL,
      selectors: () => new Selectors(this),
    })

    this.feature.registerExtraReducers(
      extraReducers.resetOnContextChange(this),
      extraReducers.resetOnEditingComplete(this),
    )

    this.feature.registerEffects(
      effects.executeLoad(this),
      effects.loadForCurrentEntity(this),
      effects.loadForCurrentEntityOnEditedEntityChange(this),
      effects.loadOnContextChange(this),
      effects.loadForCurrentEntityOnTargetSet(this),
      effects.releaseCurrentEntityTarget(this),
      effects.releaseCurrentEntityTargetOnEditingComplete(this),
      effects.setCurrentEntityTarget(this),
      effects.updateCalculationMode(this),
      effects.updateManualFunctionalization(this),
    )
  }
}

export namespace Plugin {
  export namespace constructor {
    export interface Params {
      collection: ec.Collection<TypeParams>
    }
  }
}
